import React, {Component} from 'react';
import LandingHeader from './LandingHeader'
import Footer from '../Footer'
import LandingMain from '../Landing/LandingMain.js'

class Landing extends Component {
  componentDidMount() {
    const isScrollToDescription = window.location.hash === '#description';
    if(isScrollToDescription) {
      setTimeout(function () {
        window.scrollTo(0, 10000);
      }, 200)
    }
  }

  render() {
    return (
      <div>
        <LandingHeader isShowAddress={true}/>
        <LandingMain/>
        <Footer/>
      </div>
    );
  }
}

export default Landing;


// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js